import React from "react";
import { Card, Flex } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import { memberType } from "../../../../types/member";
import { formatNumber } from "../../../../utils/formatNumber";

type BalanceCardProps = {
  data: memberType;
  platform: string | null;
};

const BalanceCard: React.FC<BalanceCardProps> = ({
  data,
  platform
}: BalanceCardProps) => {
  const { t } = useTranslation();
  if (data.consumption === null) {
    return;
  }

  let currencyString = data.currency;
  let consumption = formatNumber(data.consumption);

  if (data.currency === "JPY") {
    currencyString = t("{{ currency }}", { currency: data.currency });
    consumption = t("{{ amount }}", { amount: formatNumber(data.consumption) });
  }

  // The consumption label depends on what each EC platform's `consumption`
  // value actually represents (see harmony internal/app/service/platform/*):
  // - flaps / 91app: spending within the current membership-level period
  // - cyberbiz: current-calendar-year paid orders (annual)
  // - shopify: recent-orders total, flagged via is_60_days_consumption
  // - shopline (default): lifetime historical order total
  const consumptionLabel = (() => {
    if (platform === "flaps" || platform === "91app") {
      return t("Consumption Accumulation During Membership Level Period");
    }
    if (platform === "cyberbiz") {
      return t("Annual consumption accumulation");
    }
    if (data?.is_60_days_consumption) {
      return t("60-day consumption accumulation");
    }
    return t("Historical Consumption Accumulation");
  })();

  return (
    <Card
      styles={{
        body: {
          padding: 0,
        },
      }}
      bordered={false}
      className="rounded-[12px]"
    >
      <Flex vertical className="w-full p-[16px] ">
        <Flex justify="center" align="center" className="h-[45px]" gap={"8px"}>
          <Paragraph className="h2-medium">{currencyString}</Paragraph>
          <Paragraph className="text-center value-style">
            {consumption}
          </Paragraph>
        </Flex>
        <Paragraph className="text-center note-regular text-o-body font-notoSansTC">
          {consumptionLabel}
        </Paragraph>
      </Flex>
    </Card>
  );
};
export default BalanceCard;
